import React from 'react';
import { Form, Input, Button, Modal, Row, Col, Typography, Card, Space } from 'antd';
import { UserOutlined, LockOutlined, ArrowLeftOutlined, SafetyOutlined } from '@ant-design/icons';
import API_ROUTES from '../../api';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import GsrdWch from '../../components/GsrdWch';

const { Title, Text, Paragraph, Link } = Typography;

export default function ManageLogin() {
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const onFinish = (values) => {
        axios.post(API_ROUTES.api_manage_login, {
            userName: values.email,
            password: values.password,
        }).then(function (response) {
            if (response.data.code === 500) {
                Modal.error({ 
                    title: 'Login Failed',
                    content: response.data.msg 
                });
            } else {
                Modal.success({ 
                    title: 'Welcome',
                    content: 'Administrator login successful!' 
                });
                localStorage.setItem('userInfo', response.data.data.userInfo);
                localStorage.setItem("email", response.data.data.email);
                localStorage.setItem('id', response.data.data.id);
                navigate('/manage');
            }
        }).catch(function (error) {
            Modal.error({ 
                title: 'Error',
                content: error.response?.data?.msgDes || "Login failed. Please check administrator credentials." 
            });
        });
    };

    return (
        <div className="shared-auth-page" style={{ backgroundColor: '#f0f5ff', minHeight: '100vh', paddingBottom: '80px' }}>
            {/* Header Section */}
            <div className="shared-auth-hero-banner" style={{
                height: '260px',
                padding: '60px 20px',
                textAlign: 'center',
                color: 'white',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <Button 
                    type="text" 
                    icon={<ArrowLeftOutlined />} 
                    style={{ color: 'white', position: 'absolute', left: '20px', top: '20px' }}
                    onClick={() => navigate('/login')}
                >
                    User Portal
                </Button>
                <div style={{ marginBottom: '16px' }}>
                     <img
                        src={"https://gsrd-server.tos-cn-beijing.volces.com/gsrdlogonowch%20(2).png"}
                        style={{ height: '50px', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))' }}
                        alt="GSRD Logo"
                    />
                </div>
                <Title level={1} style={{ color: 'white', margin: 0, fontWeight: 800 }}>Admin Access</Title>
                <Paragraph style={{ color: 'rgba(255,255,255,0.8)', marginTop: '8px', fontSize: '16px' }}>
                    Secure portal for <GsrdWch /> system administrators.
                </Paragraph>
            </div>

            {/* Login Card */}
            <div className="shared-auth-card-wrap">
                <Card 
                    bordered={false} 
                    style={{ 
                        width: '100%', 
                        maxWidth: '440px', 
                        borderRadius: '24px', 
                        boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '40px' }}
                >
                    <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                        <div style={{ 
                            width: '64px', 
                            height: '64px', 
                            background: '#fff7e6', 
                            borderRadius: '50%', 
                            margin: '0 auto 16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fa8c16',
                            fontSize: '28px'
                        }}>
                            <SafetyOutlined />
                        </div>
                        <Title level={3} style={{ color: '#055878', margin: 0 }}>Administrator Login</Title>
                    </div>

                    <Form
                        name="admin_login"
                        layout="vertical"
                        onFinish={onFinish}
                        form={form}
                        size="large"
                        requiredMark={false}
                    >
                        <Form.Item
                            label={<Text strong>Admin Email</Text>}
                            name="email"
                            rules={[{ required: true, message: 'Please input admin email!' }]}
                        >
                            <Input 
                                prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} 
                                placeholder="Admin email" 
                                style={{ borderRadius: '10px' }}
                            />
                        </Form.Item>

                        <Form.Item
                            label={<Text strong>Password</Text>}
                            name="password"
                            rules={[{ required: true, message: 'Please input admin password!' }]}
                        >
                            <Input.Password 
                                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} 
                                placeholder="Password" 
                                style={{ borderRadius: '10px' }}
                            />
                        </Form.Item>

                        <Form.Item style={{ marginTop: '32px', marginBottom: 0 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                block
                                style={{
                                    height: '54px',
                                    background: 'linear-gradient(135deg, #055878 0%, #13769a 100%)',
                                    border: 'none',
                                    borderRadius: '27px',
                                    fontWeight: '700',
                                    fontSize: '18px',
                                    boxShadow: '0 8px 20px rgba(5, 88, 120, 0.25)'
                                }}
                            >
                                Admin Login
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
            
            <div style={{ textAlign: 'center', marginTop: '40px' }}>
                <Text type="secondary" style={{ fontSize: '13px' }}>
                    Restricted Access Area | Authorized Personnel Only
                </Text>
            </div>
        </div>
    );
}
